import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveButton from 'src/components/app/SaveButton';
import useUser from 'src/components/app/useUser';
import { useSnackbar } from 'notistack';
import $api from '../http';
import { useTranslation } from 'react-i18next';

const ApiKeyDialog = (props) => {
  const { t } = useTranslation();
  const {
    open,
    onClose = () => {},
    onSubmit = () => {},
  } = props;
  const [isLoading, setIsLoading] = useState();
  const { getUser, setUserData } = useUser();
  const [user, setUser] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    $api.post('/user/api-key', {})
      .catch(() => {
        setIsLoading(false);
        return null;
      })
      .then((response) => {
        if (response) {
          setIsLoading(false);
          setUser(response.data);
          setUserData(response.data);
          onSubmit(response.data);
        }
      });
  };

  const loadUser = async () => {
    const u = await getUser();
    setUser(u);
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  useEffect(() => {
    if (isOpen) {
      loadUser();
    }
  }, [isOpen]);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(user.api_key).then(() => {
      enqueueSnackbar(t('API key has been copied to clipboard'), {
        variant: 'success'
      });
    }, () => {
      enqueueSnackbar(t('API key has not been copied to clipboard. Please use browser functionality.'), {
        variant: 'error'
      });
    });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t('Your API key')}
      </DialogTitle>
      <DialogContent>
        <Grid sx={{ mt: 2 }} container spacing={1}>
          <Grid item lg={9}>
            <TextField
              size="small"
              type="text"
              fullWidth
              value={user.api_key || ''}
            />
          </Grid>
          <Grid item lg={3}>
            <Button
              fullWidth
              sx={{ height: '100%' }}
              type="button"
              variant="contained"
              startIcon={<ContentCopyIcon />}
              onClick={handleCopyClick}
            >
              {t('Copy')}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SaveButton
          onClick={handleSubmit}
          color="error"
          variant="contained"
          disableElevation
          startIcon=""
          autoFocus
          loading={isLoading}
          label={t('Re-generate API KEY')}
        />
        <Button variant="outlined" onClick={handleClose} color="primary">
          {t('Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ApiKeyDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ApiKeyDialog;
